import React from "react";
import { useLang } from "@/context/LangContext";
import { Languages } from "lucide-react";

/**
 * Highly visible language toggle (pill).
 * Lives next to the GST toggle in the topbar.
 */
export default function LangToggle({ className = "" }) {
  const { lang, toggle } = useLang();
  const isTagalog = lang === "tl";

  return (
    <button
      type="button"
      onClick={toggle}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 border font-mono text-[10px] uppercase tracking-wider transition-colors ${
        isTagalog
          ? "bg-[var(--secondary)]/15 text-[var(--secondary)] border-[var(--secondary)]/50"
          : "border-[var(--border)] text-zinc-400 hover:border-[var(--secondary)]"
      } ${className}`}
      title={
        isTagalog
          ? "Taglish · click to switch to English"
          : "English · click to switch to Taglish"
      }
      aria-pressed={isTagalog}
      aria-label={isTagalog ? "Switch to English" : "Switch to Taglish"}
      data-testid="lang-toggle-pill"
    >
      <Languages size={12} strokeWidth={2.5} />
      {isTagalog ? "TL" : "EN"}
    </button>
  );
}
